import { FormattedMessage } from "react-intl";

import { kibelaClient } from "../../utils/kibela_client";
import { confirmAsync } from "../ConfirmDialog";
import { Link } from "../Link";
import { KibelaSymbol } from "../shared/kibela_symbol";

type Props = Readonly<{
  teams: ReadonlyArray<Team>;
  intl: any;
}>;

export interface Team {
  subdomain: string;
  url: string;
  isCurrent: boolean;
}

export const TeamSwitchMenu: React.FC<Props> = ({ teams, intl }) => {
  const handleRemoveTeam = async (target: Team) => {
    const { subdomain } = target;
    const isConfirmed = await confirmAsync({
      intl,
      title: <FormattedMessage id="header.removeLoggedInTeam.title" />,
      content: (
        <FormattedMessage
          id="header.removeLoggedInTeam.description"
          values={{
            a: (chunks) => <a href={`https://${subdomain}.kibe.la`}>{chunks}</a>,
            subdomain,
          }}
        />
      ),
      okButtonLabel: <FormattedMessage id="shared.verbs.remove" />,
      okButtonClassName: "is-button-warning",
    });

    if (isConfirmed) {
      await kibelaClient.deleteTeamLoggedIn(subdomain);
      location.reload();
    }
  };

  return teams.length > 1 ? (
    <>
      <li>
        <span className="headerNavigation-avatarDropdown-titleItem">
          <FormattedMessage id="header.switchTeam" />
        </span>
      </li>
      {teams.map((team) => (
        <li key={team.subdomain}>
          {team.isCurrent ? (
            <span className="headerNavigation-avatarDropdown-currentTeam">{team.subdomain}</span>
          ) : (
            <div className="headerNavigation-avatarDropdown-otherTeam">
              <Link to={team.url}>{team.subdomain}</Link>
              <button type="button" onClick={() => handleRemoveTeam(team)}>
                <KibelaSymbol id="close" />
              </button>
            </div>
          )}
        </li>
      ))}
    </>
  ) : null;
};
